/** 鹿聆实验仅识别明确的实验组；未命中和异常值均保留老客服。 */
export const LULING_CHAT_EXPERIMENT_KEY = 'luling_chat';

export interface CustomerServiceSelection {
  deskType: 'instadesk' | 'zendesk' | 'shulex';
  instadeskUrl: string;
  shulexIframeUrl: string;
  iframeProvider: 'shulex' | 'luling';
}

/** 配置来自外部 jsonvalue，新客服地址必须是可嵌入的 HTTP(S) 绝对地址。 */
export function normalizeChatUrl(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:' ? value.trim() : '';
  } catch {
    return '';
  }
}

/** 沿用老客服类型与端开关，仅在实验组且新地址有效时选择鹿聆 iframe。 */
export function resolveCustomerService(
  value: unknown,
  isMobile: boolean,
  group: unknown,
): CustomerServiceSelection {
  const config = value && typeof value === 'object' ? (value as Record<string, unknown>) : {};
  const instadeskUrl = typeof config.shulex_url === 'string' ? config.shulex_url : '';
  const lulingUrl = normalizeChatUrl(config.luling_url);
  if ((group === 2 || group === '2') && lulingUrl) {
    return {
      deskType: 'shulex',
      instadeskUrl,
      shulexIframeUrl: lulingUrl,
      iframeProvider: 'luling',
    };
  }
  const legacyShulex = config.desk_type === 'shulex' && config.id && config.token;
  const enableInstadesk = isMobile ? config.enable_instadesk_m : config.enable_instadesk_pc;
  return {
    deskType: legacyShulex ? 'shulex' : enableInstadesk ? 'instadesk' : 'zendesk',
    instadeskUrl,
    shulexIframeUrl: legacyShulex ? instadeskUrl : '',
    iframeProvider: 'shulex',
  };
}
